import { Box, List, ListItem, ListItemText, Typography } from "@mui/material";
import dayjs from "dayjs";
import { LeadMovementHistory } from "../types/LeadBoardTypes";

interface MovementHistoryProps {
  history: LeadMovementHistory[];
}

const MovementHistory = ({ history }: MovementHistoryProps) => (
  <Box mt={2}>
    <Typography variant="h6" gutterBottom>
      Movement History
    </Typography>
    {history.length === 0 ? (
      <Typography variant="body2">No history available.</Typography>
    ) : (
      <List dense>
        {history.map((h) => (
          <ListItem key={h.id} disablePadding>
            <ListItemText
              primary={`${h.status}${h.assignedTo ? ` - ${h.assignedTo}` : ""}`}
              secondary={dayjs(h.changedAt).format("MM/DD/YYYY")}
            />
          </ListItem>
        ))}
      </List>
    )}
  </Box>
);

export default MovementHistory;
